/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-07-21 15:27:35
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-07-21 15:46:34
 * @FilePath: \crm-product\found\views\tpm\views\budget\budget_fee\form\enable-remark.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Form from '../../../../../../components/form';
import request from '../../../../../../utils/request';

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'enable_form',
    };
  },
  methods: {
    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'attachmentList') {
        v.props = {
          ...v.props,
          fileMsg: '请上传: pdf,docx,xlsx,ppt,png,jpg等格式',
          accept: '.pdf,.docx,.xlsx,.ppt,.png,.jpg,.jpeg,.gif',
          limit: 5,
        };
      }
      return v;
    },
    // 表单渲染完成后回调
    formComplete() {},
    // 提交
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        const url = this.formConfig.code === 'enable' ? '/tpm/tpmFeeBudgetController/enable' : '/tpm/tpmFeeBudgetController/disable';
        const params = {
          ...formData,
          ids: this.formConfig.selection,
        };
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
